<script setup lang="ts">
import { computed } from "vue";
import { CartButton } from "~/templates/partials/header/CartButton";
import { MyBritaButton } from "~/templates/partials/header/MyBritaButton";
import { HamburgerMenu } from "~/components/clarity-ui/HamburgerMenu";
import useCommonLabels from "~/composables/useCommonLabels";
import useMainNavigationState from "~/composables/useMainNavigationState";
import useMarketSetup from "~/composables/useMarketSetup";

const { marketSetupAdmin } = useMarketSetup();
const { isMobileMode, isMobileOpen } = useMainNavigationState();
const { getLabelByPath } = useCommonLabels();

const cartButtonAriaLabel = computed(() => getLabelByPath("BWF/shared/cartButtonAriaLabel"));
const myBritaButtonAriaLabel = computed(() => getLabelByPath("BWF/shared/myBritaButtonAriaLabel"));
const hamburgerMenuAriaLabelClosed = computed(() =>
  getLabelByPath("BWF/shared/hamburgerMenuAriaLabelClosed"),
);
const hamburgerMenuAriaLabelOpened = computed(() =>
  getLabelByPath("BWF/shared/hamburgerMenuAriaLabelOpened"),
);
</script>

<template>
  <nav class="flex flex-none items-center gap-1" data-testid="utility-navigation">
    <CartButton v-if="marketSetupAdmin?.cartPage" :aria-label="cartButtonAriaLabel" />
    <MyBritaButton
      v-if="marketSetupAdmin?.myBritaOverviewPage"
      :aria-label="myBritaButtonAriaLabel"
    />
    <HamburgerMenu
      v-if="isMobileMode"
      v-model="isMobileOpen"
      :aria-label-closed="hamburgerMenuAriaLabelClosed"
      :aria-label-opened="hamburgerMenuAriaLabelOpened"
    />
  </nav>
</template>
